import { Routes, Route } from "react-router-dom";
import InventoriesManagePage from "./building-management/inventories/InventoriesManagePage";
import InventoriesPage from "./building-management/inventories/InventoriesPage";
import RoomsManagePage from "./building-management/rooms/RoomsManagePage";
import RoomsPage from "./building-management/rooms/RoomsPage";
import UsersManagePage from "./users/UsersManagePage";
import UsersPage from "./users/UsersPage";
import BookingsPage from "./building-management/bookings/BookingsPage";
import BookingCreatePage from "./building-management/bookings/create/BookingCreatePage";
import BookingManagePage from "./building-management/bookings/manage/BookingsManagePage";
import AuthenticationLogoutPage from "./authentication/AuthenticationLogoutPage";
import NotFoundPage from "./general/NotFoundPage";
import BuildingManagement from "./building-management/BuildingManagement";
import ReportUsers from "./building-management/bookings/report/ReportUsers";
import ReportSecurity from "./building-management/bookings/report/ReportSecurity";

const RoutesAdmin = () => {
  return (
    <Routes>
      {/* Bookings */}
      <Route path="/building-management/bookings/report-users" element={<ReportUsers />} />
      <Route path="/building-management/bookings/report-security" element={<ReportSecurity />} />
      <Route path="/building-management/bookings/create" element={<BookingCreatePage />} />
      <Route path="/building-management/bookings/:id" element={<BookingManagePage />} />
      <Route path="/building-management/bookings" element={<BookingsPage />} />

      {/* Rooms */}
      <Route path="/building-management/rooms/:id" element={<RoomsManagePage />} />
      <Route path="/building-management/rooms" element={<RoomsPage />} />

      {/* Inventories */}
      <Route path="/building-management/inventories/:id" element={<InventoriesManagePage />} />
      <Route path="/building-management/inventories" element={<InventoriesPage />} />

      {/* Users */}
      <Route path="/users/:id" element={<UsersManagePage />} />
      <Route path="/users" element={<UsersPage />} />

      {/* Dashboard */}
      <Route path="/sign-out" element={<AuthenticationLogoutPage />} />
      <Route path="/" element={<BuildingManagement />} />

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default RoutesAdmin;